import * as types from '../actions';

const initialState = {
	loading:false
};

export default function(state = initialState, action) {
    const response = action.response;

    switch(action.type) {

        case types.SHOW_LOADER:
            return {...state, loading:true};
        case types.HIDE_LOADER:
            return {...state, loading:false};
        default:
            return state;

    }
}